/**
 * EDIリクエストの新規申請（未加入）
 */
import * as httpConst from '../../../constants/httpConst'
import Vue from 'vue'

const unsubscribed = {
  namespaced: true,
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
    /**
     * 未加入者用の新規申請情報を取得
     * @param {Object} context - Vuexコンテキスト
     * @param {Object} params - パラメータ
     * @param {string} params.token - EDIリクエストトークン
     * @returns {Promise} 申請情報
     */
    new({ commit }, { token }) {
      const api_path = `${httpConst.EDI_REQUEST_ENDPOINT}/edi_requests/${token}/unsubscribeds/new`
      return new Promise((resolve, reject) => {
        Vue.$http.get(api_path).then(data => {
          let content = data.content
          resolve(content)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
     * 未加入者用の新規申請を作成
     * @param {Object} context - Vuexコンテキスト
     * @param {Object} params - パラメータ
     * @param {string} params.token - EDIリクエストトークン
     * @param {Object} params.data - 申請データ
     * @returns {Promise} 作成結果
     */
    create({ commit }, { token, data }) {
      const api_path = `${httpConst.EDI_REQUEST_ENDPOINT}/edi_requests/${token}/unsubscribeds`
      return new Promise((resolve, reject) => {
        Vue.$http.post(api_path, data).then(response => {
          let content = response.content
          resolve(content)
        }).catch(error => {
          reject(error)
        })
      })
    },
    show ({ commit }, { id }) {
      const api_path = `${httpConst.ADMIN_ENDPOINT}/edi_requests/${id}/unsubscribeds`
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then(data => {
          commit
          resolve(data.content)
        })
      })
    },
    /**
     * 未加入者用の編集情報を取得
     * @param {Object} context - Vuexコンテキスト
     * @param {Object} params - パラメータ
     * @param {number} params.id - EDIリクエストID
     * @returns {Promise} 申請情報
     */
    edit({ commit }, { id }) {
      const api_path = `${httpConst.ADMIN_ENDPOINT}/edi_requests/${id}/unsubscribeds/edit`
      return new Promise((resolve, reject) => {
        Vue.$http.get(api_path).then(data => {
          let content = data.content
          resolve(content)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
     * 未加入者用の申請を更新
     * @param {Object} context - Vuexコンテキスト
     * @param {Object} params - パラメータ
     * @param {number} params.id - EDIリクエストID
     * @param {Object} params.data - 申請データ
     * @returns {Promise} 更新結果
     */
    update({ commit }, { id, data }) {
      const api_path = `${httpConst.ADMIN_ENDPOINT}/edi_requests/${id}/unsubscribeds`
      return new Promise((resolve, reject) => {
        Vue.$http.put(api_path, data).then(response => {
          let content = response.content
          commit('snackbar/showInfo', { message: '更新しました' }, { root: true })
          resolve(content)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
     * 未加入者用の申請を削除
     * @param {Object} context - Vuexコンテキスト
     * @param {Object} params - パラメータ
     * @param {number} params.id - EDIリクエストID
     * @returns {Promise} 削除結果
     */
    destroy({ commit }, { id }) {
      const api_path = `${httpConst.ADMIN_ENDPOINT}/edi_requests/${id}/unsubscribeds`
      return new Promise((resolve, reject) => {
        Vue.$http.delete(api_path).then(response => {
          let content = response.content
          commit('snackbar/showInfo', { message: '削除しました' }, { root: true })
          resolve(content)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
     * 未加入者用の申請データをサーバーサイドでバリデーション
     * @param {Object} context - Vuexコンテキスト
     * @param {Object} params - パラメータ
     * @param {string} params.token - EDIリクエストトークン
     * @param {Object} params.data - 申請データ
     * @returns {Promise} バリデーション結果
     */
    validate({ commit }, { token, data }) {
      const api_path = `${httpConst.EDI_REQUEST_ENDPOINT}/edi_requests/${token}/unsubscribeds/validate`
      return new Promise((resolve, reject) => {
        Vue.$http.post(api_path, data).then(response => {
          resolve(response.content)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
     * 未加入者用の編集データをサーバーサイドでバリデーション（管理画面用）
     * @param {Object} context - Vuexコンテキスト
     * @param {Object} params - パラメータ
     * @param {number} params.id - EDIリクエストID
     * @param {Object} params.data - 申請データ
     * @returns {Promise} バリデーション結果
     */
    validateEdit({ commit }, { id, data }) {
      const api_path = `${httpConst.ADMIN_ENDPOINT}/edi_requests/${id}/unsubscribeds/validate`
      return new Promise((resolve, reject) => {
        Vue.$http.post(api_path, data).then(response => {
          resolve(response.content)
        }).catch(error => {
          reject(error)
        })
      })
    },
  },
}

export default unsubscribed
